import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, PanelRightClose, SquarePen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button';
import { TooltipProvider } from '@/components/ui/tooltip';

interface ChatPanelHeaderProps {
  title: string;
  history: React.ReactNode;
  historyOpen: boolean;
  onHistoryOpenChange: (open: boolean) => void;
  onNewChat: () => void;
  onClose: () => void;
}

const ChatPanelHeader: React.FC<ChatPanelHeaderProps> = ({
  title,
  history,
  historyOpen,
  onHistoryOpenChange,
  onNewChat,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <TooltipProvider>
      <header className="flex h-14 shrink-0 items-center gap-1 border-b px-2">
        <Popover open={historyOpen} onOpenChange={onHistoryOpenChange}>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="min-w-0 flex-1 justify-start gap-1.5 font-medium"
            >
              <span className="truncate">{title}</span>
              <ChevronDown
                className={`shrink-0 text-muted-foreground transition-transform ${historyOpen ? 'rotate-180' : ''}`}
                strokeWidth={1.8}
              />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="revy-ui w-auto p-0">
            {history}
          </PopoverContent>
        </Popover>

        <TooltipIconButton
          size="icon-sm"
          label={t('chat.newChat')}
          icon={<SquarePen strokeWidth={1.8} />}
          onClick={onNewChat}
        />
        <TooltipIconButton
          size="icon-sm"
          label={t('chat.closePanel')}
          icon={<PanelRightClose strokeWidth={1.8} />}
          onClick={onClose}
        />
      </header>
    </TooltipProvider>
  );
};

export default ChatPanelHeader;
